module.exports = __webpack_public_path__ + "img/cancun-bay-pool-2.bfca0bde.jpg";